/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AwsConfigurationSecretsmanagerMessage {
  credentials?: AwsConfigurationSecretsmanagerMessageCredentialsMessage;
  endpoint?: string;
  kmskey?: string;
  region?: string;
}

export interface AwsConfigurationSecretsmanagerMessageCredentialsMessage {
  accesskey?: string;
  secretkey?: string;
  token?: string;
}

export interface AzureConfigurationKeyvaultMessage {
  credentials?: AzureConfigurationKeyvaultMessageCredentialsMessage;
  endpoint?: string;
}

export interface AzureConfigurationKeyvaultMessageCredentialsMessage {
  clientId?: string;
  clientSecret?: string;
  tenantId?: string;
}

export interface GcpConfigurationSecretmanagerMessage {
  credentials?: GcpConfigurationSecretmanagerMessageCredentialsMessage;
  endpoint?: string;
  projectId?: string;
}

export interface GcpConfigurationSecretmanagerMessageCredentialsMessage {
  clientEmail?: string;
  clientId?: string;
  privateKey?: string;
  privateKeyId?: string;
}

export interface GemaltoConfigurationKeysecureMessage {
  credentials?: GemaltoConfigurationKeysecureMessageCredentialsMessage;
  endpoint?: string;
}

export interface GemaltoConfigurationKeysecureMessageCredentialsMessage {
  domain?: string;
  /** @format int64 */
  retry?: string;
  token?: string;
}

export interface OperatorRpcsAddPoolBody {
  pool?: MinioOpPool;
}

export interface OperatorRpcsCreateTenantBody {
  namespace?: string;
  name?: string;
  image?: string;
  features?: MinioAddEnterpriseFeatures;
  pools?: MinioOpPool[];
  mountPath?: string;
  accessKey?: string;
  secretKey?: string;
  disableTls?: boolean;
  disableConsole?: boolean;
  /** @format int32 */
  erasureCodingParity?: number;
  annotations?: Record<string, string>;
  labels?: Record<string, string>;
  imageRegistry?: MinioImageRegistryConfig;
  imagePullSecret?: string;
  idp?: MinioOpIdpConfiguration;
  tls?: MinioTLSConfiguration;
  encryption?: MinioOpEncryptionConfiguration;
  domains?: MinioOpDomainsConfiguration;
  environmentVariables?: Record<string, string>;
  exposeMinio?: boolean;
  exposeConsole?: boolean;
  exposeSFTP?: boolean;
}

export interface OperatorRpcsDeleteTenantBody {
  deletePvcs?: boolean;
}

export interface OperatorRpcsUpdatePoolBody {
  pools?: MinioOpPool[];
}

export interface OperatorRpcsUpdateTenantBody {
  image?: string;
  features?: MinioAddEnterpriseFeatures;
  pools?: MinioOpPool[];
  mountPath?: string;
  accessKey?: string;
  secretKey?: string;
  disableTls?: boolean;
  disableConsole?: boolean;
  /** @format int32 */
  erasureCodingParity?: number;
  annotations?: Record<string, string>;
  labels?: Record<string, string>;
  imageRegistry?: MinioImageRegistryConfig;
  imagePullSecret?: string;
  idp?: MinioOpIdpConfiguration;
  tls?: MinioTLSConfiguration;
  encryption?: MinioOpEncryptionConfiguration;
  domains?: MinioOpDomainsConfiguration;
  environmentVariables?: Record<string, string>;
  exposeMinio?: boolean;
  exposeConsole?: boolean;
  exposeSFTP?: boolean;
}

export interface OperatorRpcsUpdateTenantDomainsBody {
  minio?: string[];
  console?: string;
}

/**
 * A node selector represents the union of the results of one or more label queries
 * over a set of nodes; that is, it represents the OR of the selectors represented
 * by the node selector terms.
 * +structType=atomic
 */
export interface Corev1NodeSelector {
  /**
   * Required. A list of node selector terms. The terms are ORed.
   * +listType=atomic
   */
  nodeSelectorTerms?: V1NodeSelectorTerm[];
}

/**
 * The pod this Toleration is attached to tolerates any taint that matches
 * the triple <key,value,effect> using the matching operator <operator>.
 */
export interface Corev1Toleration {
  /**
   * Key is the taint key that the toleration applies to. Empty means match all taint keys.
   * If the key is empty, operator must be Exists; this combination means to match all values and all keys.
   * +optional
   */
  key?: string;
  /**
   * Operator represents a key's relationship to the value.
   * Valid operators are Exists and Equal. Defaults to Equal.
   * Exists is equivalent to wildcard for value, so that a pod can
   * tolerate all taints of a particular category.
   * +optional
   */
  operator?: string;
  /**
   * Value is the taint value the toleration matches to.
   * If the operator is Exists, the value should be empty, otherwise just a regular string.
   * +optional
   */
  value?: string;
  /**
   * Effect indicates the taint effect to match. Empty means match all taint effects.
   * When specified, allowed values are NoSchedule, PreferNoSchedule and NoExecute.
   * +optional
   */
  effect?: string;
  /**
   * TolerationSeconds represents the period of time the toleration (which must be
   * of effect NoExecute, otherwise this field is ignored) tolerates the taint. By default,
   * it is not set, which means tolerate the taint forever (do not evict). Zero and
   * negative values will be treated as 0 (evict immediately) by the system.
   * +optional
   * @format int64
   */
  tolerationSeconds?: string;
}

export interface GooglerpcStatus {
  /** @format int32 */
  code?: number;
  message?: string;
  details?: ProtobufAny[];
}

export interface MinioActiveDirectoryConf {
  url?: string;
  groupSearchBaseDn?: string;
  groupSearchFilter?: string;
  skipTlsVerification?: boolean;
  serverInsecure?: boolean;
  serverStartTls?: boolean;
  lookupBindDn?: string;
  lookupBindPassword?: string;
  userDnSearchBaseDn?: string;
  userDnSearchFilter?: string;
  userDns?: string[];
  groupDns?: string;
}

export interface MinioAddEnterpriseFeatures {
  cache?: MinioCacheConfiguration;
  firewall?: MinioFirewallConfigData;
}

export interface MinioAddress {
  s3?: string;
  console?: string;
  sftp?: string;
  health?: string;
}

export interface MinioAllocatableResourcesResponse {
  /** @format int64 */
  minAllocatableMem?: string;
  /** @format int64 */
  minAllocatableCPU?: string;
  cpuPriority?: MinioNodeMaxAllocatableResources;
  memPriority?: MinioNodeMaxAllocatableResources;
}

export interface MinioAwsConfiguration {
  secretsmanager?: AwsConfigurationSecretsmanagerMessage;
}

export interface MinioAzureConfiguration {
  keyvault?: AzureConfigurationKeyvaultMessage;
}

export interface MinioBandwidth {
  DownloadRate?: string;
  downloadRatePerSec?: string;
  UploadRate?: string;
  uploadRatePerSec?: string;
}

export interface MinioBucketCache {
  maxMemory?: string;
  name?: string;
}

export interface MinioBucketRule {
  bucket?: string;
  label?: string;
  access?: string;
  anonymous?: string;
  bandwidth?: MinioBandwidth;
  requests?: MinioRequest[];
}

export interface MinioCacheConfiguration {
  /**
   * string name = 1;
   * string self = 2;
   * repeated string peers = 3;
   */
  buckets?: MinioBucketCache[];
  /** float version = 5; */
  tls?: MinioTLSCache;
  defaultMaxMemory?: string;
}

export interface MinioCertificateBundle {
  key?: string;
  crt?: string;
  ca?: string;
}

export interface MinioClaims {
  claim?: string[];
}

export interface MinioCreateTenantResponse {
  externalIDP?: boolean;
  console?: MinioTenantResponseItem[];
  /** Id of the tenant that was just created */
  id?: string;
}

export interface MinioCsrElement {
  status?: string;
  name?: string;
  namespace?: string;
  annotations?: Record<string, string>;
}

export interface MinioCsrElements {
  csrElement?: MinioCsrElement[];
}

export type MinioEmpty = object;

export interface MinioEndpoint {
  s3?: string;
  console?: string;
}

export interface MinioEnvVar {
  name?: string;
  /** TODO: add valuefrom */
  value?: string;
}

export interface MinioEventList {
  items?: MinioResourceEvent[];
}

export interface MinioFirewallConfigData {
  version?: string;
  server?: MinioServerConfig;
  minio?: MinioMinioConfig;
  name?: string;
}

export interface MinioGcpConfiguration {
  secretmanager?: GcpConfigurationSecretmanagerMessage;
}

export interface MinioGemaltoConfiguration {
  keysecure?: GemaltoConfigurationKeysecureMessage;
}

export interface MinioHealth {
  path?: string;
  interval?: string;
}

export interface MinioImageRegistryConfig {
  registry?: string;
  username?: string;
  password?: string;
}

export interface MinioKeyPairConfiguration {
  crt?: string;
  key?: string;
}

export interface MinioKeys {
  accessKey?: string;
  secretKey?: string;
}

export interface MinioLimits {
  /** @format int64 */
  memory?: string;
  /** @format int64 */
  cpu?: string;
}

export interface MinioMetadataFields {
  annotations?: Record<string, string>;
  labels?: Record<string, string>;
  nodeSelector?: Record<string, string>;
}

export interface MinioMinioConfig {
  endpoint?: MinioEndpoint;
  health?: MinioHealth;
  tls?: MinioTLSConfigMinio;
  rules?: MinioRule;
}

export interface MinioNodeMaxAllocatableResources {
  /** @format int64 */
  maxAllocatableCPU?: string;
  /** @format int64 */
  maxAllocatableMem?: string;
}

export interface MinioOIDCConf {
  configurationUrl?: string;
  clientId?: string;
  secretId?: string;
  callbackUrl?: string;
  claimName?: string;
  scopes?: string;
}

export interface MinioOpDomainsConfiguration {
  minio?: string[];
  console?: string;
}

export interface MinioOpEncryptionConfiguration {
  metadatafields?: MinioMetadataFields;
  raw?: string;
  image?: string;
  replicas?: string;
  secretsToBeDeleted?: string[];
  serverTls?: MinioKeyPairConfiguration;
  minioMtls?: MinioKeyPairConfiguration;
  kmsMtls?: MinioCertificateBundle;
  policies?: Record<string, string>;
  gemalto?: MinioGemaltoConfiguration;
  aws?: MinioAwsConfiguration;
  vault?: MinioVaultConfiguration;
  gcp?: MinioGcpConfiguration;
  azure?: MinioAzureConfiguration;
  /**
   * PodSecurityContext holds pod-level security attributes and common container settings.
   * Some fields are also present in container.securityContext.  Field values of
   * container.securityContext take precedence over field values of PodSecurityContext.
   */
  securityContext?: V1PodSecurityContext;
  exposeMinio?: boolean;
  exposeConsole?: boolean;
  exposeSftp?: boolean;
}

export interface MinioOpIdpConfiguration {
  oidc?: MinioOIDCConf;
  keys?: MinioKeys[];
  activeDirectory?: MinioActiveDirectoryConf;
}

export interface MinioOpLicense {
  email?: string;
  organization?: string;
  /** @format int64 */
  accountId?: string;
  /** @format int64 */
  storageCapacity?: string;
  plan?: string;
  expiresAt?: string;
}

export interface MinioOpPool {
  name?: string;
  /** @format int32 */
  servers?: number;
  /** @format int32 */
  volumesPerServer?: number;
  volumeConfiguration?: MinioVolumeConfiguration;
  resources?: MinioResourceRequirements;
  nodeSelector?: Record<string, string>;
  /** Affinity is a group of affinity scheduling rules. */
  affinity?: V1Affinity;
  runtimeClassName?: string;
  tolerations?: Corev1Toleration[];
  /**
   * PodSecurityContext holds pod-level security attributes and common container settings.
   * Some fields are also present in container.securityContext.  Field values of
   * container.securityContext take precedence over field values of PodSecurityContext.
   */
  securityContext?: V1PodSecurityContext;
}

export interface MinioOpTenant {
  name?: string;
  creationDate?: string;
  deletionDate?: string;
  currentState?: string;
  pools?: MinioOpPool[];
  image?: string;
  namespace?: string;
  /** @format int64 */
  totalSize?: string;
  subnetLicense?: MinioOpLicense;
  endpoints?: MinioTenantEndpoints;
  idpAdEnabled?: boolean;
  idpOidcEnabled?: boolean;
  encryptionEnabled?: boolean;
  status?: MinioOpTenantStatus;
  minioTLS?: boolean;
  domains?: MinioOpDomainsConfiguration;
  tiers?: MinioTenantTierElement[];
  sftpExposed?: boolean;
}

export interface MinioOpTenantStatus {
  /** @format int32 */
  writeQuorum?: number;
  /** @format int32 */
  drivesOnline?: number;
  /** @format int32 */
  drivesOffline?: number;
  /** @format int32 */
  drivesHealing?: number;
  healthStatus?: string;
  usage?: MinioOpTenantStatusUsage;
}

export interface MinioOpTenantStatusUsage {
  /** @format int64 */
  raw?: string;
  /** @format int64 */
  rawUsage?: string;
  /** @format int64 */
  capacity?: string;
  /** @format int64 */
  capacityUsage?: string;
}

export interface MinioPVCDescribe {
  name?: string;
  namespace?: string;
  storageClass?: string;
  status?: string;
  volume?: string;
  labels?: Record<string, string>;
  annotations?: Record<string, string>;
  finalizers?: string[];
  capacity?: string;
  accessModes?: string[];
  volumeMode?: string;
}

export interface MinioPod {
  name?: string;
  status?: string;
  /** @format int64 */
  timeCreated?: string;
  podIP?: string;
  /** @format int32 */
  restarts?: number;
  node?: string;
}

export interface MinioPodList {
  pods?: MinioPod[];
}

export interface MinioRequest {
  api?: string;
  /** @format int64 */
  rate?: string;
  /** @format int64 */
  burst?: string;
}

export interface MinioRequests {
  /** @format int64 */
  memory?: string;
  /** @format int64 */
  cpu?: string;
}

export interface MinioResourceEvent {
  namespace?: string;
  /** @format int64 */
  lastSeen?: string;
  eventType?: string;
  reason?: string;
  object?: string;
  message?: string;
}

export interface MinioResourceRequirements {
  requests?: MinioRequests;
  limits?: MinioLimits;
  claims?: MinioClaims;
}

export interface MinioRule {
  anonymous?: string;
  buckets?: MinioBucketRule[];
}

export interface MinioSerializedSwagger {
  /** @format byte */
  serialized?: string;
}

export interface MinioServerConfig {
  address?: MinioAddress;
  tls?: MinioTLSConfigServer;
}

export interface MinioTLSCache {
  publicKey?: string;
  privateKey?: string;
  caPath?: string;
  clientAuth?: boolean;
}

export interface MinioTLSConfigMinio {
  cacert?: string;
  insecure?: boolean;
}

export interface MinioTLSConfigServer {
  letsEncrypt?: boolean;
  cert?: string;
  key?: string;
}

export interface MinioTLSConfiguration {
  minioServerCertificates?: MinioKeyPairConfiguration[];
  minioClientCertificates?: MinioKeyPairConfiguration[];
  minioCAsCertificates?: string[];
}

export interface MinioTenantEndpoints {
  minio?: string;
  console?: string;
}

export interface MinioTenantResponseItem {
  accessKey?: string;
  secretKey?: string;
  url?: string;
}

export interface MinioTenantTierElement {
  name?: string;
  type?: string;
  /** @format int64 */
  size?: string;
}

export interface MinioVaultConfiguration {
  approle?: MinioVaultConfigurationApproleMessage;
  endpoint?: string;
  engine?: string;
  namespace?: string;
  prefix?: string;
  status?: MinioVaultConfigurationStatusMessage;
}

export interface MinioVaultConfigurationApproleMessage {
  engine?: string;
  id?: string;
  /** @format int64 */
  retry?: string;
  secret?: string;
}

export interface MinioVaultConfigurationStatusMessage {
  /** @format int64 */
  ping?: string;
}

export interface MinioVolumeConfiguration {
  /** @format int64 */
  size?: string;
  storageClassName?: string;
  labels?: Record<string, string>;
  annotations?: Record<string, string>;
}

export interface ProtobufAny {
  "@type"?: string;
  [key: string]: any;
}

/** Affinity is a group of affinity scheduling rules. */
export interface V1Affinity {
  /**
   * Describes node affinity scheduling rules for the pod.
   * +optional
   * Node affinity is a group of node affinity scheduling rules.
   */
  nodeAffinity?: V1NodeAffinity;
  /**
   * Describes pod affinity scheduling rules (e.g. co-locate this pod in the same node, zone, etc. as some other pod(s)).
   * +optional
   * Pod affinity is a group of inter pod affinity scheduling rules.
   */
  podAffinity?: V1PodAffinity;
  /**
   * Describes pod anti-affinity scheduling rules (e.g. avoid putting this pod in the same node, zone, etc. as some other pod(s)).
   * +optional
   * Pod anti affinity is a group of inter pod anti affinity scheduling rules.
   */
  podAntiAffinity?: V1PodAntiAffinity;
}

/**
 * A label selector is a label query over a set of resources. The result of matchLabels and
 * matchExpressions are ANDed. An empty label selector matches all objects. A null
 * label selector matches no objects.
 * +structType=atomic
 */
export interface V1LabelSelector {
  /**
   * matchLabels is a map of {key,value} pairs. A single {key,value} in the matchLabels
   * map is equivalent to an element of matchExpressions, whose key field is "key", the
   * operator is "In", and the values array contains only "value". The requirements are ANDed.
   * +optional
   */
  matchLabels?: Record<string, string>;
  /**
   * matchExpressions is a list of label selector requirements. The requirements are ANDed.
   * +optional
   * +listType=atomic
   */
  matchExpressions?: V1LabelSelectorRequirement[];
}

/**
 * A label selector requirement is a selector that contains values, a key, and an operator that
 * relates the key and values.
 */
export interface V1LabelSelectorRequirement {
  /** key is the label key that the selector applies to. */
  key?: string;
  /**
   * operator represents a key's relationship to a set of values.
   * Valid operators are In, NotIn, Exists and DoesNotExist.
   */
  operator?: string;
  /**
   * values is an array of string values. If the operator is In or NotIn,
   * the values array must be non-empty. If the operator is Exists or DoesNotExist,
   * the values array must be empty. This array is replaced during a strategic
   * merge patch.
   * +optional
   * +listType=atomic
   */
  values?: string[];
}

/** Node affinity is a group of node affinity scheduling rules. */
export interface V1NodeAffinity {
  /**
   * If the affinity requirements specified by this field are not met at
   * scheduling time, the pod will not be scheduled onto the node.
   * If the affinity requirements specified by this field cease to be met
   * at some point during pod execution (e.g. due to an update), the system
   * may or may not try to eventually evict the pod from its node.
   * +optional
   */
  requiredDuringSchedulingIgnoredDuringExecution?: Corev1NodeSelector;
  /**
   * The scheduler will prefer to schedule pods to nodes that satisfy
   * the affinity expressions specified by this field, but it may choose
   * a node that violates one or more of the expressions. The node that is
   * most preferred is the one with the greatest sum of weights, i.e.
   * for each node that meets all of the scheduling requirements (resource
   * request, requiredDuringScheduling affinity expressions, etc.),
   * compute a sum by iterating through the elements of this field and adding
   * "weight" to the sum if the node matches the corresponding matchExpressions; the
   * node(s) with the highest sum are the most preferred.
   * +optional
   * +listType=atomic
   */
  preferredDuringSchedulingIgnoredDuringExecution?: V1PreferredSchedulingTerm[];
}

/**
 * A node selector requirement is a selector that contains values, a key, and an operator
 * that relates the key and values.
 */
export interface V1NodeSelectorRequirement {
  /** The label key that the selector applies to. */
  key?: string;
  /**
   * Represents a key's relationship to a set of values.
   * Valid operators are In, NotIn, Exists, DoesNotExist. Gt, and Lt.
   */
  operator?: string;
  /**
   * An array of string values. If the operator is In or NotIn,
   * the values array must be non-empty. If the operator is Exists or DoesNotExist,
   * the values array must be empty. If the operator is Gt or Lt, the values
   * array must have a single element, which will be interpreted as an integer.
   * This array is replaced during a strategic merge patch.
   * +optional
   * +listType=atomic
   */
  values?: string[];
}

/**
 * A null or empty node selector term matches no objects. The requirements of
 * them are ANDed.
 * The TopologySelectorTerm type implements a subset of the NodeSelectorTerm.
 * +structType=atomic
 */
export interface V1NodeSelectorTerm {
  /**
   * A list of node selector requirements by node's labels.
   * +optional
   * +listType=atomic
   */
  matchExpressions?: V1NodeSelectorRequirement[];
  /**
   * A list of node selector requirements by node's fields.
   * +optional
   * +listType=atomic
   */
  matchFields?: V1NodeSelectorRequirement[];
}

/** Pod affinity is a group of inter pod affinity scheduling rules. */
export interface V1PodAffinity {
  /**
   * If the affinity requirements specified by this field are not met at
   * scheduling time, the pod will not be scheduled onto the node.
   * If the affinity requirements specified by this field cease to be met
   * at some point during pod execution (e.g. due to a pod label update), the
   * system may or may not try to eventually evict the pod from its node.
   * When there are multiple elements, the lists of nodes corresponding to each
   * podAffinityTerm are intersected, i.e. all terms must be satisfied.
   * +optional
   * +listType=atomic
   */
  requiredDuringSchedulingIgnoredDuringExecution?: V1PodAffinityTerm[];
  /**
   * The scheduler will prefer to schedule pods to nodes that satisfy
   * the affinity expressions specified by this field, but it may choose
   * a node that violates one or more of the expressions. The node that is
   * most preferred is the one with the greatest sum of weights, i.e.
   * for each node that meets all of the scheduling requirements (resource
   * request, requiredDuringScheduling affinity expressions, etc.),
   * compute a sum by iterating through the elements of this field and adding
   * "weight" to the sum if the node has pods which matches the corresponding podAffinityTerm; the
   * node(s) with the highest sum are the most preferred.
   * +optional
   * +listType=atomic
   */
  preferredDuringSchedulingIgnoredDuringExecution?: V1WeightedPodAffinityTerm[];
}

/**
 * Defines a set of pods (namely those matching the labelSelector
 * relative to the given namespace(s)) that this pod should be
 * co-located (affinity) or not co-located (anti-affinity) with,
 * where co-located is defined as running on a node whose value of
 * the label with key <topologyKey> matches that of any node on which
 * a pod of the set of pods is running
 */
export interface V1PodAffinityTerm {
  /**
   * A label query over a set of resources, in this case pods.
   * If it's null, this PodAffinityTerm matches with no Pods.
   * +optional
   */
  labelSelector?: V1LabelSelector;
  /**
   * namespaces specifies a static list of namespace names that the term applies to.
   * The term is applied to the union of the namespaces listed in this field
   * and the ones selected by namespaceSelector.
   * null or empty namespaces list and null namespaceSelector means "this pod's namespace".
   * +optional
   * +listType=atomic
   */
  namespaces?: string[];
  /**
   * This pod should be co-located (affinity) or not co-located (anti-affinity) with the pods matching
   * the labelSelector in the specified namespaces, where co-located is defined as running on a node
   * whose value of the label with key topologyKey matches that of any node on which any of the
   * selected pods is running.
   * Empty topologyKey is not allowed.
   */
  topologyKey?: string;
  /**
   * A label query over the set of namespaces that the term applies to.
   * The term is applied to the union of the namespaces selected by this field
   * and the ones listed in the namespaces field.
   * null selector and null or empty namespaces list means "this pod's namespace".
   * An empty selector ({}) matches all namespaces.
   * +optional
   */
  namespaceSelector?: V1LabelSelector;
  /**
   * MatchLabelKeys is a set of pod label keys to select which pods will
   * be taken into consideration. The keys are used to lookup values from the
   * incoming pod labels, those key-value labels are merged with `labelSelector` as `key in (value)`
   * to select the group of existing pods which pods will be taken into consideration
   * for the incoming pod's pod (anti) affinity. Keys that don't exist in the incoming
   * pod labels will be ignored. The default value is empty.
   * The same key is forbidden to exist in both matchLabelKeys and labelSelector.
   * Also, matchLabelKeys cannot be set when labelSelector isn't set.
   * This is an alpha field and requires enabling MatchLabelKeysInPodAffinity feature gate.
   * +listType=atomic
   * +optional
   */
  matchLabelKeys?: string[];
  /**
   * MismatchLabelKeys is a set of pod label keys to select which pods will
   * be taken into consideration. The keys are used to lookup values from the
   * incoming pod labels, those key-value labels are merged with `labelSelector` as `key notin (value)`
   * to select the group of existing pods which pods will be taken into consideration
   * for the incoming pod's pod (anti) affinity. Keys that don't exist in the incoming
   * pod labels will be ignored. The default value is empty.
   * The same key is forbidden to exist in both mismatchLabelKeys and labelSelector.
   * Also, mismatchLabelKeys cannot be set when labelSelector isn't set.
   * This is an alpha field and requires enabling MatchLabelKeysInPodAffinity feature gate.
   * +listType=atomic
   * +optional
   */
  mismatchLabelKeys?: string[];
}

/** Pod anti affinity is a group of inter pod anti affinity scheduling rules. */
export interface V1PodAntiAffinity {
  /**
   * If the anti-affinity requirements specified by this field are not met at
   * scheduling time, the pod will not be scheduled onto the node.
   * If the anti-affinity requirements specified by this field cease to be met
   * at some point during pod execution (e.g. due to a pod label update), the
   * system may or may not try to eventually evict the pod from its node.
   * When there are multiple elements, the lists of nodes corresponding to each
   * podAffinityTerm are intersected, i.e. all terms must be satisfied.
   * +optional
   * +listType=atomic
   */
  requiredDuringSchedulingIgnoredDuringExecution?: V1PodAffinityTerm[];
  /**
   * The scheduler will prefer to schedule pods to nodes that satisfy
   * the anti-affinity expressions specified by this field, but it may choose
   * a node that violates one or more of the expressions. The node that is
   * most preferred is the one with the greatest sum of weights, i.e.
   * for each node that meets all of the scheduling requirements (resource
   * request, requiredDuringScheduling anti-affinity expressions, etc.),
   * compute a sum by iterating through the elements of this field and adding
   * "weight" to the sum if the node has pods which matches the corresponding podAffinityTerm; the
   * node(s) with the highest sum are the most preferred.
   * +optional
   * +listType=atomic
   */
  preferredDuringSchedulingIgnoredDuringExecution?: V1WeightedPodAffinityTerm[];
}

/**
 * PodSecurityContext holds pod-level security attributes and common container settings.
 * Some fields are also present in container.securityContext.  Field values of
 * container.securityContext take precedence over field values of PodSecurityContext.
 */
export interface V1PodSecurityContext {
  /**
   * The SELinux context to be applied to all containers.
   * If unspecified, the container runtime will allocate a random SELinux context for each
   * container.  May also be set in SecurityContext.  If set in
   * both SecurityContext and PodSecurityContext, the value specified in SecurityContext
   * takes precedence for that container.
   * Note that this field cannot be set when spec.os.name is windows.
   * +optional
   */
  seLinuxOptions?: V1SELinuxOptions;
  /**
   * The Windows specific settings applied to all containers.
   * If unspecified, the options within a container's SecurityContext will be used.
   * If set in both SecurityContext and PodSecurityContext, the value specified in SecurityContext takes precedence.
   * Note that this field cannot be set when spec.os.name is linux.
   * +optional
   * WindowsSecurityContextOptions contain Windows-specific options and credentials.
   */
  windowsOptions?: V1WindowsSecurityContextOptions;
  /**
   * The UID to run the entrypoint of the container process.
   * Defaults to user specified in image metadata if unspecified.
   * May also be set in SecurityContext.  If set in both SecurityContext and
   * PodSecurityContext, the value specified in SecurityContext takes precedence
   * for that container.
   * Note that this field cannot be set when spec.os.name is windows.
   * +optional
   * @format int64
   */
  runAsUser?: string;
  /**
   * The GID to run the entrypoint of the container process.
   * Uses runtime default if unset.
   * May also be set in SecurityContext.  If set in both SecurityContext and
   * PodSecurityContext, the value specified in SecurityContext takes precedence
   * for that container.
   * Note that this field cannot be set when spec.os.name is windows.
   * +optional
   * @format int64
   */
  runAsGroup?: string;
  /**
   * Indicates that the container must run as a non-root user.
   * If true, the Kubelet will validate the image at runtime to ensure that it
   * does not run as UID 0 (root) and fail to start the container if it does.
   * If unset or false, no such validation will be performed.
   * May also be set in SecurityContext.  If set in both SecurityContext and
   * PodSecurityContext, the value specified in SecurityContext takes precedence.
   * +optional
   */
  runAsNonRoot?: boolean;
  /**
   * A list of groups applied to the first process run in each container, in addition
   * to the container's primary GID, the fsGroup (if specified), and group memberships
   * defined in the container image for the uid of the container process. If unspecified,
   * no additional groups are added to any container. Note that group memberships
   * defined in the container image for the uid of the container process are still effective,
   * even if they are not included in this list.
   * Note that this field cannot be set when spec.os.name is windows.
   * +optional
   * +listType=atomic
   */
  supplementalGroups?: string[];
  /**
   * A special supplemental group that applies to all containers in a pod.
   * Some volume types allow the Kubelet to change the ownership of that volume
   * to be owned by the pod:
   * 1. The owning GID will be the FSGroup
   * 2. The setgid bit is set (new files created in the volume will be owned by FSGroup)
   * 3. The permission bits are OR'd with rw-rw----
   *
   * If unset, the Kubelet will not modify the ownership and permissions of any volume.
   * Note that this field cannot be set when spec.os.name is windows.
   * +optional
   * @format int64
   */
  fsGroup?: string;
  /**
   * Sysctls hold a list of namespaced sysctls used for the pod. Pods with unsupported
   * sysctls (by the container runtime) might fail to launch.
   * Note that this field cannot be set when spec.os.name is windows.
   * +optional
   * +listType=atomic
   */
  sysctls?: V1Sysctl[];
  /**
   * fsGroupChangePolicy defines behavior of changing ownership and permission of the volume
   * before being exposed inside Pod. This field will only apply to
   * volume types which support fsGroup based ownership(and permissions).
   * It will have no effect on ephemeral volume types such as: secret, configmaps
   * and emptydir.
   * Valid values are "OnRootMismatch" and "Always". If not specified, "Always" is used.
   * Note that this field cannot be set when spec.os.name is windows.
   * +optional
   */
  fsGroupChangePolicy?: string;
  /**
   * The seccomp options to use by the containers in this pod.
   * Note that this field cannot be set when spec.os.name is windows.
   * +optional
   */
  seccompProfile?: V1SeccompProfile;
}

/**
 * An empty preferred scheduling term matches all objects with implicit weight 0
 * (i.e. it's a no-op). A null preferred scheduling term matches no objects (i.e. is also a no-op).
 */
export interface V1PreferredSchedulingTerm {
  /**
   * Weight associated with matching the corresponding nodeSelectorTerm, in the range 1-100.
   * @format int32
   */
  weight?: number;
  /** A node selector term, associated with the corresponding weight. */
  preference?: V1NodeSelectorTerm;
}

/** SELinuxOptions are the labels to be applied to the container */
export interface V1SELinuxOptions {
  /**
   * User is a SELinux user label that applies to the container.
   * +optional
   */
  user?: string;
  /**
   * Role is a SELinux role label that applies to the container.
   * +optional
   */
  role?: string;
  /**
   * Type is a SELinux type label that applies to the container.
   * +optional
   */
  type?: string;
  /**
   * Level is SELinux level label that applies to the container.
   * +optional
   */
  level?: string;
}

/**
 * SeccompProfile defines a pod/container's seccomp profile settings.
 * Only one profile source may be set.
 * +union
 */
export interface V1SeccompProfile {
  /**
   * type indicates which kind of seccomp profile will be applied.
   * Valid options are:
   * Localhost - a profile defined in a file on the node should be used.
   * RuntimeDefault - the container runtime default profile should be used.
   * Unconfined - no profile should be applied.
   * +unionDiscriminator
   */
  type?: string;
  /**
   * localhostProfile indicates a profile defined in a file on the node should be used.
   * The profile must be preconfigured on the node to work.
   * Must be a descending path, relative to the kubelet's configured seccomp profile location.
   * Must be set if type is "Localhost". Must NOT be set for any other type.
   * +optional
   */
  localhostProfile?: string;
}

/** Sysctl defines a kernel parameter to be set */
export interface V1Sysctl {
  /** Name of a property to set */
  name?: string;
  /** Value of a property to set */
  value?: string;
}

/** The weights of all of the matched WeightedPodAffinityTerm fields are added per-node to find the most preferred node(s) */
export interface V1WeightedPodAffinityTerm {
  /**
   * weight associated with matching the corresponding podAffinityTerm,
   * in the range 1-100.
   * @format int32
   */
  weight?: number;
  /** Required. A pod affinity term, associated with the corresponding weight. */
  podAffinityTerm?: V1PodAffinityTerm;
}

/** WindowsSecurityContextOptions contain Windows-specific options and credentials. */
export interface V1WindowsSecurityContextOptions {
  /**
   * GMSACredentialSpecName is the name of the GMSA credential spec to use.
   * +optional
   */
  gmsaCredentialSpecName?: string;
  /**
   * GMSACredentialSpec is where the GMSA admission webhook
   * (https://github.com/kubernetes-sigs/windows-gmsa) inlines the contents of the
   * GMSA credential spec named by the GMSACredentialSpecName field.
   * +optional
   */
  gmsaCredentialSpec?: string;
  /**
   * The UserName in Windows to run the entrypoint of the container process.
   * Defaults to the user specified in image metadata if unspecified.
   * May also be set in PodSecurityContext. If set in both SecurityContext and
   * PodSecurityContext, the value specified in SecurityContext takes precedence.
   * +optional
   */
  runAsUserName?: string;
  /**
   * HostProcess determines if a container should be run as a 'Host Process' container.
   * All of a Pod's containers must have the same effective HostProcess value
   * (it is not allowed to have a mix of HostProcess containers and non-HostProcess containers).
   * In addition, if HostProcess is true then HostNetwork must also be set to true.
   * +optional
   */
  hostProcess?: boolean;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title operator.proto
 * @version version not set
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name GetAllocatableResource
     * @request GET:/api/v2/sites/{siteID}/cluster/allocatable_resources
     */
    getAllocatableResource: (
      siteId: string,
      query?: {
        /** @format int32 */
        numNodes?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioAllocatableResourcesResponse, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/cluster/allocatable_resources`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name ListTenants
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/tenants
     */
    listTenants: (
      siteId: string,
      namespace: string,
      query?: {
        resourceID?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioSerializedSwagger, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/tenants`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name GetTenant
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/tenants/{resourceID}
     */
    getTenant: (
      siteId: string,
      namespace: string,
      resourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioOpTenant, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/tenants/${resourceId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name DeleteTenant
     * @request DELETE:/api/v2/sites/{siteID}/namespaces/{namespace}/tenants/{resourceID}
     */
    deleteTenant: (
      siteId: string,
      namespace: string,
      resourceId: string,
      body: OperatorRpcsDeleteTenantBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/tenants/${resourceId}`,
        method: "DELETE",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name UpdateTenant
     * @request PUT:/api/v2/sites/{siteID}/namespaces/{namespace}/tenants/{resourceID}
     */
    updateTenant: (
      siteId: string,
      namespace: string,
      resourceId: string,
      body: OperatorRpcsUpdateTenantBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/tenants/${resourceId}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name ListTenantCsRs
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/tenants/{resourceID}/csr
     */
    listTenantCsRs: (
      siteId: string,
      namespace: string,
      resourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioCsrElements, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/tenants/${resourceId}/csr`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name UpdateTenantDomains
     * @request PUT:/api/v2/sites/{siteID}/namespaces/{namespace}/tenants/{resourceID}/domains
     */
    updateTenantDomains: (
      siteId: string,
      namespace: string,
      resourceId: string,
      body: OperatorRpcsUpdateTenantDomainsBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/tenants/${resourceId}/domains`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name ListTenantEvents
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/tenants/{resourceID}/events
     */
    listTenantEvents: (
      siteId: string,
      namespace: string,
      resourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioEventList, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/tenants/${resourceId}/events`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name ListPods
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/tenants/{resourceID}/pods
     */
    listPods: (
      siteId: string,
      namespace: string,
      resourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioPodList, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/tenants/${resourceId}/pods`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name DeleteTenantPod
     * @request DELETE:/api/v2/sites/{siteID}/namespaces/{namespace}/tenants/{resourceID}/pods/{podName}
     */
    deleteTenantPod: (
      siteId: string,
      namespace: string,
      resourceId: string,
      podName: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/tenants/${resourceId}/pods/${podName}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name ListPodEvents
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/tenants/{resourceID}/pods/{podName}/events
     */
    listPodEvents: (
      siteId: string,
      namespace: string,
      resourceId: string,
      podName: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioEventList, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/tenants/${resourceId}/pods/${podName}/events`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name AddPool
     * @request POST:/api/v2/sites/{siteID}/namespaces/{namespace}/tenants/{resourceID}/pools
     */
    addPool: (
      siteId: string,
      namespace: string,
      resourceId: string,
      body: OperatorRpcsAddPoolBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/tenants/${resourceId}/pools`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name UpdatePool
     * @request PUT:/api/v2/sites/{siteID}/namespaces/{namespace}/tenants/{resourceID}/pools
     */
    updatePool: (
      siteId: string,
      namespace: string,
      resourceId: string,
      body: OperatorRpcsUpdatePoolBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioOpTenant, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/tenants/${resourceId}/pools`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name DeleteTenantPvc
     * @request DELETE:/api/v2/sites/{siteID}/namespaces/{namespace}/tenants/{resourceID}/pvc/{pvcName}
     */
    deleteTenantPvc: (
      siteId: string,
      namespace: string,
      resourceId: string,
      pvcName: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/tenants/${resourceId}/pvc/${pvcName}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name ListPvcEvents
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/tenants/{resourceID}/pvc/{pvcName}/events
     */
    listPvcEvents: (
      siteId: string,
      namespace: string,
      resourceId: string,
      pvcName: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioEventList, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/tenants/${resourceId}/pvc/${pvcName}/events`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name DescribeTenantPvc
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/tenants/{resourceID}/pvcs/{pvcName}/describe
     */
    describeTenantPvc: (
      siteId: string,
      namespace: string,
      resourceId: string,
      pvcName: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioPVCDescribe, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/tenants/${resourceId}/pvcs/${pvcName}/describe`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OperatorRpcs
     * @name CreateTenant
     * @request POST:/api/v2/sites/{siteID}/tenants
     */
    createTenant: (
      siteId: string,
      body: OperatorRpcsCreateTenantBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioCreateTenantResponse, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/tenants`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
